<template>
  <m-demo-box demo-option="businessQuickPicks" :hasSaveQuickPick="true">
    <div slot="top">
      <m-demo-all-check />
    </div>
    <b-row style="margin-top: 8px">
      <b-col>
        <div style="margin-left: 16px;">
          <div class="m-disabled-box"  v-show="isAllHoseholds"></div>
          <p v-if="quickPicks.length === 0 && init">There is no Quick Pick</p>
          <m-loader :show="!init"/>
          <div class="quick-item-box">
            <template  v-for="item in quickPicks">
            <div  @click="clickItem(item)"
                 class="quick-item"
                 data-test="demo-businessQuickPick-item"
                 :class="{'quick-item-selected': item.selected}">
                {{item.QpName}} <span v-on:click.stop="seeDetail(item)" class="item-span" :class="{ 'quick-span-selected':item.selected}">View</span>
            </div>
            </template>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal ref="seeQuickPick" title="My Business Quickpick Information" :ok-only="true" :lazy="true" @hidden="clear">
      <p>Quickpick Name: {{quickPick.Name}}</p>
      <p>Quickpick Desc: {{quickPick.QpDesc}}</p>
      <div class="card card-quick-pick" v-if="detailList.length > 0">
          <div v-for="item in detailList">
            <p class="item-value">{{item.IndustryCode + ':' + item.IndustryDesc}} <span class="item-span">{{item.IsExcluded? 'Omitted ': 'Selected'}}</span></p>
          </div>
        </div>
    </b-modal>
  </m-demo-box>
</template>

<script>
  import MDemoBox from '@/components/demo/MDemoBox'
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'

  export default {
    components: {
      MDemoBox,
      MDemoAllCheck
    },
    data () {
      return {
        quickPick: {},
        init: false,
        theQuickPicks: [],
        detailList: []
      }
    },
    computed: {
      quickPicks () {
        // let quickPicks = this.$store.state.demo.quickPicks
        if (this.theQuickPicks.length === 0 && !this.init) {
          this.getQuickPick()
          return []
        }
        if (this.$store.state.demo.saveNewQuickPick) {
          this.getQuickPick()
          return []
        }
        let quickPicks = this.theQuickPicks
        for (let i = 0; i < quickPicks.length; i++) {
          quickPicks[i].QpName = quickPicks[i].Name
          quickPicks[i].QpDesc = quickPicks[i].Name

          let hasSelected = false
          for (let selected of this.selectedQuickPicks) {
            if (quickPicks[i].QpName === selected.AttributeValueName) {
              hasSelected = true
            }
          }
          quickPicks[i].selected = hasSelected
        }
        return quickPicks
      },
      columnQuickPicks () {
        return this.$store.getters['order/demoColumnItem']('Business QuickPicks', 5)
      },
      selectedQuickPicks () {
        if (this.columnQuickPicks && this.columnQuickPicks.Values) {
          return this.columnQuickPicks.Values
        } else {
          return []
        }
      },
      listType () {
        return this.$store.state.order.ListType
      },
      type () {
        if (this.$route.name === 'demo-businessQuickPicks') {
          return 'business'
        } else {
          return 'normal'
        }
      },
      demoOption () {
        return 'businessQuickPicks'
      },
      isAllHoseholds () {
        return this.$store.getters['order/isAllHoseholds']
      }
    },
    watch: {
      '$route.params.listType' () {
        this.getQuickPick()
      }
    },
    created () {
    },
    methods: {
      addQuick (item) {
        this.$store.commit('order/saveDemoType', 1)

        let quickPick = {
          AttributeName: 'Quick Pick',
          DemoCategoryType: 2,
          AttributeValue: item.QpId,
          AttributeValueName: item.QpName,
          ColumnName: 'Quick Pick',
          SortSeq: 0
        }

        if (item.qpType === 1) {
          quickPick.AttributeName = 'Site Quick Pick'
          quickPick.ColumnName = 'Site Quick Pick'
        }
        quickPick.AttributeValue = item.QpName
        quickPick.AttributeName = 'Business QuickPicks'
        quickPick.ColumnName = 'Business QuickPicks'
        quickPick.DemoCategoryType = 5

        this.$store.dispatch('order/addDemoByItem', quickPick)
      },
      removeQuick (item) {
        item.columnName = 'Business QuickPicks'
        item.demoCategoryType = 5
        item.name = ''
        item.attributeValue = item.QpName
        item.value = 'value'
        item.name = item.QpName
        this.$store.dispatch('order/deleteDemo', item)
      },
      clickItem (item) {
        if (item.selected) {
          this.removeQuick(item)
        } else {
          this.addQuick(item)
        }
      },
      seeDetail (item) {
        this.detailList = []
        this.quickPick = item
        this.$refs.seeQuickPick.show()
        this.$http.post('PlaceOrder.aspx/GetBusinessQuickpicksDetail', {
          quickPickCode: item.Code,
          listType: this.listType
        }).then(resp => {
          this.detailList = resp.body.d.DataSource
        })
      },
      clearQuick () {
        this.$store.commit('order/deleteDemoColumnName', 'Quick Pick')
        this.$store.commit('order/deleteDemoColumnName', 'Site Quick Pick')
        this.$store.commit('order/deleteDemoColumnName', 'Business QuickPicks')
      },
      getQuickPick () {
        this.theQuickPicks = []
        this.init = false
        this.$http.post('PlaceOrder.aspx/GetBusinessQuickpicks', {
          listType: this.listType
        }).then(resp => {
          // this.$store.commit('demo/saveQuickPicks', resp.body.d.DataSource)
          this.theQuickPicks = resp.body.d.DataSource
          this.init = true
          this.$store.commit('demo/saveKey', ['saveNewQuickPick', false])
        }, () => {
          this.init = true
        })
      },
      clear () {
        this.quickPick = {}
      }
    }
  }
</script>

<style scoped lang="scss">
/*TODO@Pony need update color*/
.quick-item-icon {
  padding: 8px 16px;
  color: $color-text-grey;
  cursor: pointer;
  margin-left: 8px;
}
.quick-item-icon.light{
  color:$color-primary;
}
.item-value {
  margin-left: 8px;
}

.card-quick-pick {
  position: relative;
  padding: 8px;
  height: 500px;
  overflow-y: auto;
  border: 1px solid $color-border !important;
  border-radius: 4px;
}
.title {
  margin-top: 8px
}
.quick-item-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start
}
.quick-item {
  width: calc(33.33% - 16px);
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 8px;
  cursor: pointer;
  background-color: $color-body;
  border: 1px solid $color-border;
  border-radius: 5px;
  padding: 8px;
  min-height: 60px;
}

@media(max-width: 768px) {
  .quick-item {
    width: calc(50% - 8px);
  }
}

.quick-item-selected {
  background-color: $color-primary;
  color: $color-white;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #3C96D2;
}

  .quick-span-selected {
    color: $color-white !important;
  }

  .item-span {
    color: $color-primary;
  }

</style>



// WEBPACK FOOTER //
// src/pages/order/DemoBusinessQuickPick.vue